// Vendor imports
const _ = require('lodash')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
const { parseTemplate } = require('shared/model-helpers/meta-template')

function wrapArticle(article, streamMeta) {
  /**
   * The `meta` field is used to convey context and does not
   * represent persisted model data; move it to the streamItem
   * so that the context is retained, but separate from the article
   * @see https://redux.js.org/recipes/structuringreducers/normalizingstateshape
   */
  const {
    meta: articleMeta,
    ...normalizedArticle
  } = article
  let recReason = _.get(articleMeta, 'rec_reason')
  if (recReason) {
    const html = parseTemplate(recReason)
    // Attach parsed meta-template to rec_reason
    recReason = { ...recReason, html }
  }
  return {
    type: modelTypes.ARTICLE,
    id: article['url_id'],
    article: normalizedArticle,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: streamMeta.urlRecId || streamMeta.recId,
      recPosition: _.get(articleMeta, 'rec_position'),
      recReason
    }
  }
}

function wrapCollection(collection, streamMeta) {
  return {
    type: modelTypes.MIX,
    id: collection.id,
    collection,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: streamMeta.mixRecId || streamMeta.recId
    }
  }
}

function wrapInterest(interest, streamMeta) {
  return {
    type: modelTypes.INTEREST,
    id: interest.key,
    interest,
    meta: {
      recId: streamMeta.interestRecId || streamMeta.recId
    }
  }
}

function wrapUser(user, streamMeta) {
  return {
    type: modelTypes.USER,
    id: user.id,
    user,
    meta: {
      // Handle interleaved streams; fall back to non-interleaved
      recId: streamMeta.userRecId || streamMeta.recId
    }
  }
}

function wrapFeedItem(feedItem, streamMeta = {}) {
  const modelType = feedItem.type
  switch (modelType) {
    case modelTypes.ARTICLE:
      return wrapArticle(feedItem, streamMeta)
    case modelTypes.INTEREST:
      return wrapInterest(feedItem, streamMeta)
    case modelTypes.MIX:
      return wrapCollection(feedItem, streamMeta)
    case modelTypes.USER:
      return wrapUser(feedItem, streamMeta)
    default:
      if (modelType) {
        throw new Error(`Unsupported feedItem.type[${modelType}]`)
      }
      throw new Error(`Missing feedItem.type`)
  }
}

function wrapFeedStream(stream) {
  const streamMeta = stream.meta || {}
  return {
    items: stream.items.map(item => wrapFeedItem(item, streamMeta)),
    meta: streamMeta
  }
}

module.exports = {
  wrapArticle,
  wrapCollection,
  wrapFeedItem,
  wrapFeedStream
}
